// src/config/constants.js
// Shared constants — single source of truth for all page components

export const LOADING_STATES = {
    IDLE: 'idle',
    LOCATION_SEARCH: 'location_search',
    DEM_LOADING: 'dem_loading',
    LULC_LOADING: 'lulc_loading',
    KHASRA_LOADING: 'khasra_loading',
    CROP_LOADING: 'crop_loading',
};

export const GEO_SERVER_BASE_URL =
    process.env.REACT_APP_GEO_SERVER_URL ||
    "https://crop.geo.quantasip.com/geoserver/ne";

export const MAP_DEFAULT_CENTER = [20, 78];
export const MAP_DEFAULT_ZOOM = 5;
export const FIT_BOUNDS_PADDING = [40, 40];

export const TILE_URLS = {
    satellite: "https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
    hybrid: "https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}",
    osm: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
};

export const API_BASE = process.env.REACT_APP_API_URL || "";
export const DEBUG = process.env.REACT_APP_GEO_DEBUG === "1";
